module.exports = __webpack_public_path__ + "img/projectile1.640a9829.png";